"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpsellActions = void 0;
var _appActions = require("../../store/appActions");
var _uiActions = require("../../store/ui/uiActions");
var _services = require("../../services");
var _uiSelectors = require("../../store/ui/uiSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useUpsellActions = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const isCheckoutInProgress = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectIsCheckoutInProgress);
  const onNext = _ref => {
    var _selectedHandset$sele, _selectedHandset$sele2, _selectedPlan$selecte, _selectedPlan$selecte2, _selectedBroadband$se, _selectedBroadband$se2, _selectedBusinessSolu, _selectedBusinessSolu2;
    let {
      selectedHandset,
      selectedPlan,
      selectedUpsellProducts,
      selectedBroadband,
      selectedBusinessSolution
    } = _ref;
    const handsetProductId = (_selectedHandset$sele = selectedHandset === null || selectedHandset === void 0 ? void 0 : (_selectedHandset$sele2 = selectedHandset.selectedVariant) === null || _selectedHandset$sele2 === void 0 ? void 0 : _selectedHandset$sele2.variantId) !== null && _selectedHandset$sele !== void 0 ? _selectedHandset$sele : null;
    const planProductId = (_selectedPlan$selecte = selectedPlan === null || selectedPlan === void 0 ? void 0 : (_selectedPlan$selecte2 = selectedPlan.selectedVariant) === null || _selectedPlan$selecte2 === void 0 ? void 0 : _selectedPlan$selecte2.variantId) !== null && _selectedPlan$selecte !== void 0 ? _selectedPlan$selecte : null;
    const handsetProductName = selectedHandset === null || selectedHandset === void 0 ? void 0 : selectedHandset.productName;
    const planProductName = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productName;
    const broadbandProductId = (_selectedBroadband$se = selectedBroadband === null || selectedBroadband === void 0 ? void 0 : (_selectedBroadband$se2 = selectedBroadband.selectedVariant) === null || _selectedBroadband$se2 === void 0 ? void 0 : _selectedBroadband$se2.variantId) !== null && _selectedBroadband$se !== void 0 ? _selectedBroadband$se : null;
    const businessSolutionId = (_selectedBusinessSolu = selectedBusinessSolution === null || selectedBusinessSolution === void 0 ? void 0 : (_selectedBusinessSolu2 = selectedBusinessSolution.selectedVariant) === null || _selectedBusinessSolu2 === void 0 ? void 0 : _selectedBusinessSolu2.variantId) !== null && _selectedBusinessSolu !== void 0 ? _selectedBusinessSolu : null;
    const broadbandProductName = selectedBroadband === null || selectedBroadband === void 0 ? void 0 : selectedBroadband.productName;
    const businessSolutionName = selectedBusinessSolution === null || selectedBusinessSolution === void 0 ? void 0 : selectedBusinessSolution.productName;
    const selectedUpsellProductIds = selectedUpsellProducts.map(offering => {
      return offering.selectedVariant ? offering.selectedVariant.id : offering.id;
    });
    const upsoldProductNames = selectedUpsellProducts === null || selectedUpsellProducts === void 0 ? void 0 : selectedUpsellProducts.map(product => {
      return product.selectedVariant ? product.selectedVariant.name : product.name;
    });
    const id = `u-${selectedUpsellProducts === null || selectedUpsellProducts === void 0 ? void 0 : selectedUpsellProducts.join('-')}`;
    const time = new Date(Date.now());
    const description = `exited upselling page`;
    dispatch((0, _uiActions.updateTimestamp)([{
      id,
      time,
      description
    }]));
    dispatch((0, _appActions.checkout)({
      handsetProductId,
      planProductId,
      selectedUpsellProductIds,
      broadbandProductId,
      businessSolutionId
    }));
    _services.analytics.endJourney({
      handsetProductName,
      planProductName,
      upsoldProductNames,
      broadbandProductName,
      businessSolutionName
    });
  };
  return {
    onNext,
    isCheckoutInProgress
  };
};
exports.useUpsellActions = useUpsellActions;